<template>
<div>
  <div>
    <v-row class="mt-0">
      <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pb-0 mt-0">
        <span class="ra-span-text">บริษัทหรือเครือ</span>
        <v-autocomplete
          v-model="nameGroup"
          :items="nameGroupList"
          item-text="fullName"
          item-value="_id"
          clearable
          outlined
          dense
          class="mt-2"
          placeholder="ค้นหาจากบริษัท หรือเครือ"
          no-data-text="ไม่พบข้อมูล"
          @change="searchFilterData(), page=1"
        >
        <template v-slot:append>
          <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
        </template>
      </v-autocomplete>
      </v-col>
      <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <span class="ra-span-text">วันที่สร้างบริษัท</span>
            <v-text-field
              class="mt-2"
              v-model="dateRangeTextCreate"
              placeholder="ปป/ดด/วววว - ปป/ดด/วววว"
              readonly
              append-icon="fa-calendar-alt"
              v-bind="attrs"
              v-on="on"
              outlined
              dense
              @change="searchFilterData()"
            >
            <template v-slot:append>
              <v-icon color="#2BA197">mdi-calendar</v-icon>
            </template>
            </v-text-field>
          </template>
          <v-date-picker v-model="datesCreateAt" range></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pb-0">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <span class="ra-span-text">วันที่แก้ไขล่าสุด</span>
            <v-text-field
              v-model="dateRangeTextUpdate"
              placeholder="ค้นหา ตามวันที่แก้ไขล่าสุด"
              readonly
              v-bind="attrs"
              v-on="on"
              append-icon="fa-calendar-alt"
              class="mt-2"
              outlined
              dense
              @change="searchFilterData()"
            >
            <template v-slot:append>
              <v-icon color="#2BA197">mdi-calendar</v-icon>
            </template>
            </v-text-field>
          </template>
          <v-date-picker v-model="datesUpdateAt" range></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="1" sm="1" md="1" lg="1" class="pt-0 pb-0 align-center justify-end mt-8">
        <v-btn
          class="button-color-outline head-search-button mr-0 pl-4 pr-4"
          outlined
          elevation="0"
          @click="resetFilterData()"
        >ล้างข้อมูล</v-btn>
      </v-col>
      <v-spacer/>
      <v-col cols="2" sm="2" md="2" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-4">
        <v-btn
          outlined
          class="button-color ra-button-company"
          dark
          @click="goPage()"
        >
        <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
        <span class="ra-text-in-button-company">
          เพิ่มบริษัท
        </span>
        </v-btn>
      </v-col>
      <!-- <v-col cols="12" sm="12" md="6" lg="4" class="pt-0 pb-0 d-flex align-end">
        <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
          <v-btn class="mr-5" style="min-height: 38px;" color="success" dark @click="searchFilterData()">ค้นหา</v-btn>
          <v-btn class="" style="min-height: 38px;" outlined color="success" dark @click="resetFilterData()">ล้างข้อมูล</v-btn>
        </v-row>
      </v-col> -->
    </v-row>
  </div>
  <OverlayLoading :loading="loading" />
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    class="border-table-employee"
    :loading="loading"
    loading-text="Loading... Please wait"
    :footer-props="{
      'items-per-page-options': [15, 30, 50, 100, -1],
      'items-per-page': 15
    }"
    :server-items-length="total || -1"
    @update:items-per-page="changePerPage"
    @update:page="changePage"
    disable-sort
  >
    <template v-slot:[`item.groupCompanyName`]="{ item }">
      {{item.groupCompanyName || ' - '}}
    </template>
    <template v-slot:[`item.no`]="{ item }">
      {{ (perPage*(page-1)) + desserts.indexOf(item)+1 }}
    </template>
    <template v-slot:[`item.companyImg`]="{ item }">
      <td style="width: fit-content !important;" class="py-2">
        <v-avatar
          size="50"
          rounded
        >
          <v-img
            contain
            :lazy-src="require('@/assets/icons/company-logo3.png')"
            :src="item.failed_image ? require('@/assets/icons/company-logo3.png') : item.companyImage"
            :alt="item.employeeId"
            v-on:error="onImgError(item.no-1)"
            aspect-ratio="2.7"
          />
        </v-avatar>
      </td>
      <!-- <div class="pa-3">
        <td style="width: fit-content !important; background-color: #F5F5F5; border-radius: 4px;" class="pa-0">
        <v-avatar
            size="50"
            rounded
          >
            <v-img
              :lazy-src="require('@/assets/icons/company-logo3.png')"
              :src="item.failed_image ? require('@/assets/icons/company-logo3.png') : item.companyImage"
              :alt="item.taxId"
              v-on:error="onImgError(item.no-1)"
              aspect-ratio="2.7"
            />
          </v-avatar>
        </td>
      </div> -->
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-btn class="ma-2" outlined x-small fab color="indigo" @click="editCompany('Edit Company')"> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            rounded
            small
            dark
            icon
            class="mt-3 mb-3"
            @click="goPageEdit(item)"
          >
            <!-- @click="openDialogEditCompany(item)" -->
          <!-- <v-icon dark color="#464646" small>fa-pen</v-icon> -->
            <template v-slot>
              <v-icon small color="#2BA197">mdi-pencil-outline</v-icon>
            </template>
          </v-btn>
        </template>
        <span class="label-table-action">จัดการบริษัท</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            rounded
            dark
            small
            icon
            class="mt-3 mb-3 ml-2"
            @click="checkDel(item)"
          >
          <!-- <v-icon dark color="#464646" small>fa-trash</v-icon> -->
            <template v-slot>
              <v-icon small color="error">mdi-delete-outline</v-icon>
            </template>
          </v-btn>
        </template>
        <span class="label-table-action">ลบบริษัท</span>
      </v-tooltip>
      <!-- <v-btn class="ma-2" outlined x-small fab color="green" @click="openDialogManageCompany()">
        <v-icon>mdi-pencil</v-icon>
      </v-btn> -->
    </template>
  </v-data-table>

<!-- Dialog Create Company -->
  <v-dialog v-model="dialogCreate" persistent max-width="600px">
      <template v-slot:activator="{}">
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Create Company</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <v-tabs
                v-model="tab"
              >
                <v-tab
                  v-for="item in items"
                  :key="item.tab"
                >
                  {{ item.tab }}
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <div>
                    <TabManageGroup />
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <div class="my-2">
                    <div>
                    <TabManageCompany />
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogCreate = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="dialogCreate = false">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="delCompany()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmOrgchart" max-width="550px" persistent>
      <v-card >
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px;">บริษัทนี้ยังมีข้อมูลโครงสร้างขององค์กร</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="$router.push('managestructure/companyDetail/' + delConfirmId)">ดูข้อมูลโครงสร้างองค์กร </v-btn>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="delCompany()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Manage Company -->
    <DialogEditCompany/>
    <DialogManageCompany/>
</div>
</template>
<script>
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import TabManageGroup from './_tabManageGroup'
import TabManageCompany from './_tabManageCompany'
import DialogEditCompany from './dialogEditCompany'
import DialogManageCompany from './dialogManageCompany'
import moment from 'moment'
import OverlayLoading from '../_template/OverlayLoading.vue'

export default {
  components: {
    OverlayLoading, TabManageGroup, TabManageCompany, DialogEditCompany, DialogManageCompany
  },
  data () {
    return {
      testImage: '',
      tokenUser: '',
      search: '',
      delConfirmId: '',
      dialog: false,
      dialogCreate: false,
      dialogEdit: false,
      dialogManageCompany: false,
      dialogConfirmOrgchart: false,
      dialogConfirm: false,
      failed_image: false,
      tab: null,
      textTitle: 'Create Company',
      datesUpdateAt: [],
      datesCreateAt: [],
      menu: false,
      modal: false,
      menu2: false,
      nameGroupList: ['INET', 'OGS'],
      nameCompanyShortList: ['INET', 'OGS'],
      nameGroup: '',
      companyShortNameEng: [],
      createAt: '',
      updateAt: '',
      items: [
        { tab: 'จัดการเครือ', content: 'Tab 1 Content' },
        { tab: 'จัดการบริษัท', content: 'Tab 2 Content' }
      ],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูปภาพ', value: 'companyImg' },
        { text: 'ชื่อเครือ', value: 'groupCompanyName' },
        { text: 'ชื่อย่อบริษัท', value: 'companyShortNameEng' },
        { text: 'วันที่สร้าง', value: 'createAt' },
        { text: 'วันที่แก้ไขล่าสุด', value: 'updateAt' },
        { text: 'จัดการ', value: 'actions', sortable: false, align: 'center' }
      ],
      desserts: [],
      companyList: [],
      editedIndex: -1,
      editedItem: {
        id: '1',
        groupCompanyName: '',
        companyShortNameEng: '',
        createAt: '',
        updateAt: ''
      },
      defaultItem: {
        id: '2',
        groupCompanyName: '',
        companyShortNameEng: '',
        createAt: '',
        updateAt: ''
      },
      loading: false,
      total: -1,
      perPage: 15,
      page: 1
    }
  },
  mounted () {
    EventBus.$on('companylistrefresh', this.getCompanyRefresh)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.initialize()
    this.getCompanyLists()
    this.getSelectCompany()
    this.getCompanyRefresh()
  },
  computed: {
    dateRangeTextUpdate () {
      return this.datesUpdateAt.join(' ~ ')
    },
    dateRangeTextCreate () {
      return this.datesCreateAt.join(' ~ ')
    }
  },
  watch: {
    nameGroup: function (val) {
      // this.getCompanyLists()
    },
    companyShortNameEng: function (val) {
      // this.getCompanyLists()
    },
    datesUpdateAt: function (val) {
      if (this.datesUpdateAt[0] !== undefined && this.datesUpdateAt[1] !== undefined) {
        this.updateAt = this.datesUpdateAt[0] + ' ' + this.datesUpdateAt[1]
        this.searchFilterData()
      }
    },
    datesCreateAt: function (val) {
      if (this.datesCreateAt[0] !== undefined && this.datesCreateAt[1] !== undefined) {
        this.createAt = this.datesCreateAt[0] + ' ' + this.datesCreateAt[1]
        this.searchFilterData()
      }
    }
  },
  methods: {
    onImgError (i) {
      this.desserts[i].failed_image = true
    },
    changeFilterData () {
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.getCompanyLists()
    },
    changePerPage (value) {
      this.createAt = ''
      this.updateAt = ''
      this.perPage = value
      this.getCompanyLists()
    },
    changePage (value) {
      this.page = value
      this.getCompanyLists()
    },
    async getCompanyLists () {
      this.loading = true
      const temp = []
      const obj = {
        companyId: this.nameGroup,
        createAt: this.createAt,
        updateAt: this.updateAt,
        page: this.page,
        limit: this.perPage
      }
      // console.log('Obj', obj)
      try {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/companys/filter`,
          data: obj,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          response.data.result.map((el, index) => {
            el.companyImage = `${this.api}/api/vMonk/companys/getcompanyFileById/` + el.companyImage
            el.createAt = this.initDate(el.createAt)
            el.updateAt = this.initDate(el.updateAt)
            temp.push({
              no: index + 1,
              failed_image: false,
              ...el
            })
          })
          this.total = response?.data?.count || -1
          this.desserts = temp
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // async getImageCompanyLists () {
    //   // console.log('Value', value)
    //   this.loading = true
    //   // const tempRebuild = []
    //   // const obj = {
    //   //   companyFileId: '6041e6ae096b803d708bb84b'
    //   // }
    //   try {
    //     await this.axios({
    //       method: 'get',
    //       url: `${this.api}/api/vMonk/companys/getcompanyFileById/` + '6045dcefd80a7458382f4c35'
    //       // data: obj
    //     }).then((response) => {
    //       console.log('Image Company', response.data)
    //       this.testImage = response.data
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/select`,
        headers: {
          authorization: this.tokenUser
        }
      }).then((response) => {
        this.nameGroupList = response.data.result
        this.nameCompanyShortList = response.data.result.companyName
      }).catch(e => {
        console.log(e)
      })
    },
    checkDel (value) {
      this.delConfirmId = ''
      this.delConfirmId = value._id
      if (value.checkDeleteCompany === true) {
        this.dialogConfirm = true
      } else {
        this.dialogConfirmOrgchart = true
      }
    },
    async delCompany (id) {
      await this.axios({
        method: 'delete',
        url: `${this.api}/api/vMonk/companys/` + this.delConfirmId,
        headers: {
          authorization: this.tokenUser
        }
      }).then((response) => {
        swal('สำเร็จ', 'ลบข้อมูลสำเร็จ', 'success', {
          button: false,
          timer: 2000
        })
        this.getSelectCompany()
        this.getCompanyLists()
        this.dialogConfirm = false
      }).catch(e => {
        console.log(e)
        swal('ผิดพลาด', 'ไม่สามารถลบข้อมูลได้', 'error')
      })
    },
    searchFilterData () {
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.getCompanyLists()
    },
    resetFilterData () {
      this.datesCreateAt = []
      this.datesUpdateAt = []
      this.nameGroup = ''
      this.companyShortNameEng = []
      this.createAt = ''
      this.updateAt = ''
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.getCompanyLists()
    },
    goPage () {
      this.$router.push('/managecompany/createCompany')
    },
    goPageEdit (data) {
      // this.$router.push('/managecompany/editGroup')
      // this.$router.go('/')
      this.$router.push('managecompany/editCompany/' + data._id)
    },
    initialize () {
      this.desserts = [
        {
          id: '1',
          nameGroup: 'เครือ INET',
          companyShortNameEng: 'INET',
          createAt: '15-9-2020',
          updateAt: '15-9-2020'
        },
        {
          id: '2',
          nameGroup: 'เครือ JV',
          companyShortNameEng: 'OGS',
          createAt: '15-9-2020',
          updateAt: '15-9-2020'
        }
      ]
    },
    editCompany (value) {
      this.textTitle = ''
      this.dialogEdit = true
      this.textTitle = value
    },
    openDialogEditCompany (item) {
      this.dialogEdit = true
      EventBus.$emit('opendialogeditcompany', this.dialogEdit, item)
    },
    getCompanyRefresh (value) {
      if (value === true) {
        // this.getCompanyLists()
      }
    },
    openDialogManageCompany () {
      this.dialogManageCompany = true
      EventBus.$emit('opendialogmanagecompany', this.dialogManageCompany)
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    }
  }
}
</script>

<style scoped>
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.btn-edit-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.btn-del-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.btn-manage-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.ra-border-button {
  background: #FFFFFF;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.btn-del-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.btn-manage-dep {
  background-color: #F2F2F2 !important;
  color: #464646 !important;
}
.ra-border-button {
  background: #FFFFFF;
  /* Color / Neutral / #EEEEEE */
  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;

  border: 1px solid #EEEEEE;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
}
.ra-button-company {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #2BA197;
  border-radius: 4px;
}
.ra-text-in-button-company {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
</style>
